import React, { useContext } from "react";
import { Button, Card, Container } from "react-bootstrap";

import { useMediaQuery } from "react-responsive";
import AppContext from "../../context/AppContext";
import { Link, useNavigate } from "react-router-dom";

const ProductCard = ({ item }) => {
  const navigate = useNavigate();

  const { baseUrl, storeSelectedProduct } = useContext(AppContext);
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  return (
    <Card
      className="p-3 mx-2 my-2 rounded-5 shadow-lg"
      style={{
        height: isDesktopOrLaptop ? "400px" : "270px",
        width: isDesktopOrLaptop ? "100%" : "90%",
      }}
    >
      <Container>
        <img
          src={`${baseUrl}/storage/${item.image}`}
          style={{
            width: "100%",
            height: isDesktopOrLaptop ? "250px" : "125px",
          }}
          className="img img-fluid"
        />
      </Container>
      <Card.Body className="p-0 mt-3 ">
        {item.product_type == "Phone" ? (
          <Link
            onClick={() => {
              storeSelectedProduct(item);
            }}
            style={{ textDecoration: "none" }}
            to={"/product-details"}
          >
            <Card.Title
              style={{ fontSize: isDesktopOrLaptop ? "1rem" : "0.8rem" }}
              className="poppins-semiBold text-dark"
            >
              {item.name}
            </Card.Title>
          </Link>
        ) : (
          <Link
            onClick={() => {
              storeSelectedProduct(item);
            }}
            style={{ textDecoration: "none" }}
            to={"/product-details"}
          >
            <Card.Title
              style={{ fontSize: isDesktopOrLaptop ? "1rem" : "0.8rem" }}
              className="poppins-semiBold text-dark"
            >
              {item.name}
            </Card.Title>
          </Link>
        )}
        <Card.Text
          style={{
            fontSize: isDesktopOrLaptop ? "16px" : "12px",
            marginTop: -5,
          }}
          className="poppins-regular"
        >
          £{item.price}
        </Card.Text>
        <Button
          style={{
            color: "#FFF",
            fontSize: isDesktopOrLaptop ? "0.8rem" : "0.6rem",
            position: "absolute",
            bottom: 15,
            left: 20,
            right: 20,
          }}
          size="sm"
          variant="outline"
          className="poppins-bold gradient-bg3 px-2 py-1"
          onClick={() => {
            storeSelectedProduct(item);
            navigate("/product-details");
          }}
        >
          View Details
        </Button>
      </Card.Body>
    </Card>
  );
};

export default ProductCard;
